<template>
    <div class="d-flex align-items-center flex-column">
        <img class="image" :src="imageUrl" />
        <h6 class="text-bold mb-3 mt-4">{{firstLabel}}</h6>
        <p class="text-center mb-4" v-html="secondLabel" />
        <b-button @click="setPanelHidden" variant="outline-secondary">{{buttonLabel}}</b-button>
    </div>
</template>

<script>
    export default {
        name: "OnBoardingDone",
        props: {
            imageUrl: String,
            firstLabel: String,
            secondLabel: String,
            buttonLabel: String
        },
        methods: {
            setPanelHidden() {
                this.$emit('hidePanel')
                localStorage.setItem('onboardingPanelIsHidden', 1);
            }
        }
    }
</script>

<style scoped>
    .image {
        width: 200px;
    }
</style>
